import { render, staticRenderFns } from "./SelectMail.vue?vue&type=template&id=53998726&scoped=true"
import script from "./SelectMail.vue?vue&type=script&lang=js"
export * from "./SelectMail.vue?vue&type=script&lang=js"
import style0 from "./SelectMail.vue?vue&type=style&index=0&id=53998726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53998726",
  null
  
)

export default component.exports